<template>


  <div class="container container-tabs">

    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="24">

          <!-- 下拉选择推广标题 -->
          <span class="title">推广标题:</span>
          <el-select v-model="value_promote_code" placeholder="请选择推广标题" style="width: 150px; margin-right: 20px;"
            @visible-change="promoteVisibleChange" @change="promoteChange" clearable>
            <el-option v-for="item in options_promote_code" :key="item.value" :label="item.title"
              :value="item.driver_promote_conf_code">
            </el-option>
          </el-select>

        </el-col>
      </el-row>





      <div>

        <el-button type="primary" icon="el-icon-search" @click="searchDriverPromoteLists">搜索</el-button>
        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      </div>

    </div>


    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div class="more-style">

              <el-form-item v-if="props.row.img_one.url != ''">
                <img :src="props.row.img_one.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

              <el-form-item v-if="props.row.img_two.url != ''">
                <img :src="props.row.img_two.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

              <el-form-item v-if="props.row.img_three.url != ''">
                <img :src="props.row.img_three.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

            </div>

            <div class="more-style">

              <el-form-item v-if="props.row.img_four.url != ''">
                <img :src="props.row.img_four.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

              <el-form-item v-if="props.row.img_fives.url != ''">
                <img :src="props.row.img_fives.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

              <el-form-item v-if="props.row.img_six.url != ''">
                <img :src="props.row.img_six.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

            </div>

            <div class="more-style">

              <el-form-item v-if="props.row.img_seven.url != ''">
                <img :src="props.row.img_seven.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

              <el-form-item v-if="props.row.img_eight.url != ''">
                <img :src="props.row.img_eight.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

              <el-form-item v-if="props.row.img_nine.url != ''">
                <img :src="props.row.img_nine.url" alt="" style="width: 100px;height: 100px;">
              </el-form-item>

            </div>
          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" min-width="80">
      </el-table-column>
      <el-table-column prop="driver_details.real_name" label="司机名称" min-width="150">
      </el-table-column>
      <el-table-column prop="driver_promote_conf_details.title" label="推广标题" min-width="150">
      </el-table-column>
      <el-table-column prop="time.YmdHis" label="录入时间" min-width="150">
      </el-table-column>

      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.verify_status.val=='0'?'warning':(scope.row.verify_status.val=='1'?'':'danger')">
            {{scope.row.verify_status.alias}}</el-tag>
        </template>
      </el-table-column>








      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary"
            @click="toExamine_isShow = !toExamine_isShow; toExamine = scope.row.driver_promote_code; ">

            推广审核


          </el-button>

        </template>
      </el-table-column>



    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>



    <!-- 审核组件 -->
    <toExamine :isShow="toExamine_isShow" :data="toExamine" @onSubmit="driverPromoteLists">
    </toExamine>


  </div>


</template>

<script>
  var _this;
  import toExamine from './toExamine.vue';


  export default {
    components: {

      toExamine

    },
    data() {
      return {


        // 传入子组件的数据
        toExamine: '',

        // 下拉搜索城市
        value_promote_code: '',
        options_promote_code: [],
        promote_options_data: {
          page: 1,
          limit: 50,
        },


        // 抽屉开关按钮
        toExamine_isShow: false,



        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          driver_promote_conf_code: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {
      _this = this;
      _this.driverPromoteLists();
    },

    methods: {
      searchDriverPromoteLists(){
        _this.search_data.page = 1;
        _this.driverPromoteLists();
      },
      promoteChange(val) {

        _this.search_data.driver_promote_conf_code = val;

      },

      //搜索的下拉框弹出触发
      promoteVisibleChange(val) {

        if (val && _this.options_promote_code.length < 1) {
          // 请求公司管理接口获取公司唯一编码
          _this.$post(
            "/promote/driverPromoteConfLists",
            _this.promote_options_data
          ).then(res => {

            _this.options_promote_code = res.data

          }).catch((err) => {

          })
        }

      },





      // 搜索司机列表
      driverPromoteLists() {
        _this.$post(
            "/promote/driverPromoteLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;


          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.driverPromoteLists();

      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    max-width: 150px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>